import type { Background } from '../content/types.ts';
import type { CustomBackgroundLibrary } from '../domain/customBackground.ts';
import {
  createCustomBackgroundLibrary,
  migrateCustomBackgroundLibraryRecord,
  validateCustomBackgroundLibrary,
} from '../domain/customBackground.ts';
import type { StoragePort } from './storagePort.ts';
import { WriteQueue } from './writeQueue.ts';
import { CustomContentRepository } from './customContentRepository.ts';

/**
 * The player's own Background definitions.
 *
 * Reading, the write lock on an unreadable file, validation, the write queue
 * and the bounded backups all come from `CustomContentRepository`, the same
 * ones custom Skills get. This supplies only what is specific to Backgrounds.
 */
export class CustomBackgroundRepository extends CustomContentRepository<CustomBackgroundLibrary> {
  constructor(
    storage: StoragePort,
    now: () => string = () => new Date().toISOString(),
    queue: WriteQueue = new WriteQueue(),
  ) {
    super(
      {
        name: 'custom-backgrounds',
        label: 'custom Background',
        createEmpty: createCustomBackgroundLibrary,
        migrate: migrateCustomBackgroundLibraryRecord,
        validate: validateCustomBackgroundLibrary,
      },
      storage,
      now,
      queue,
    );
  }

  async saveBackgrounds(
    library: CustomBackgroundLibrary,
    backgrounds: readonly Background[],
  ): Promise<CustomBackgroundLibrary> {
    return this.save({ ...library, backgrounds: [...backgrounds] });
  }
}
